import React from "react"
import PageHeader from "./PageHeader"
import PageFooter from "./PageFooter"

interface PdfPageWrapperProps {
  sectionTitle?: string
  children: React.ReactNode
  onPdfViewClick?: () => void
}

const PdfPageWrapper: React.FC<PdfPageWrapperProps> = ({
  sectionTitle,
  children,
  onPdfViewClick,
}) => {
  return (
    <div className="pdf-editor-container">
      <div className="pdf-dimensions-helper">
        Letter size (8.5 inches) -{" "}
        {onPdfViewClick ? (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              onPdfViewClick()
            }}
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            PDF View
          </a>
        ) : (
          "Content will be exported as PDF"
        )}
      </div>
      <div className="pdf-document">
        <PageHeader />
        <div className="pdf-content">
          {sectionTitle && (
            <h3 className="pdf-page-section-title">{sectionTitle}</h3>
          )}
          {children}
        </div>
        <PageFooter />
      </div>
    </div>
  )
}

export default PdfPageWrapper
